export { useJwt as default };
import jwtService from './jwtService';

function useJwt(axiosIns, jwtOverrideConfig) {
  const jwt = new jwtService(axiosIns, jwtOverrideConfig);
  return {
    jwt
  };
}

